import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://iqfuwiellhwfzubowbvk.supabase.co';
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImlxZnV3aWVsbGh3Znp1Ym93YnZrIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MjgyOTA2MzMsImV4cCI6MjA0Mzg2NjYzM30.pqvwJMh_tW2GnnLtMXi24Y5_y01RMTLJK1Jp1PFkTfk';

export const supabase = createClient(supabaseUrl, supabaseKey);